import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShow", component(opts));
  editor.BlockManager.add("slideShow", block(opts));
};